import styled from 'styled-components';

export const ErrorContainer = styled.div`
  flex: 1;
  background-color: #ffffff;
  padding-horizontal: 36px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  font-family: 'Lato';
  font-weight: 400;
  height: 90vh;
`;

export const ErrorImage = styled.img`
  height: 91px;
  width: 120px;
`;

export const ErrorTitle = styled.h1`
  text-align: center;
  margin-top: 16px;
  font-size: 20px;
  line-height: 32px;
  font-family: 'Lato';
  font-weight: 700;
`;

export const ErrorMessage = styled.p`
  text-align: center;
  margin-right: 10px;
  margin-left: 10px;
  font-size: 16px;
  font-family: 'Lato';
  font-weight: 400;
`;

export const Container = styled.div`
  background-color: #ffffff;
  align-items: center;
  width: 100%;
  padding-horizontal: 36px;
  box-shadow: 0 1px 0.5px rgba(255, 255, 255, 0.2);
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled.button`
  height: 44px;
  width: 95%;
  border-radius: 4px;
  overflow: hidden;
  margin: 15px 10px;
  cursor: pointer;
  border: none;
  outline: none;
  background: linear-gradient(92deg, #53b2fe 0%, #065af3 100%);
`;

export const ButtonTitle = styled.span`
  padding-vertical: 12px;
  align-self: center;
  font-family: 'Lato';
  font-weight: 900;
  color: #ffffff;
  background-color: transparent;
  font-size: 16px;
`;